<template>
	<div class="field" :class="{ 'has-addons': hasAddons }">
		<label v-if="label && !hasAddons" class="label">{{ label }}</label>
		<p v-if="hasAddons" class="control">
			<a class="button is-static">
				{{ label }}
			</a>
		</p>
		<div class="control" :class="{ 'is-clearfix': maxlength && hasCounter }">
			<input
				class="input"
				:class="[
					{ 'is-danger': showError },
					fieldSize,
					{ 'data-hj-whitelist': whitelist }
				]"
				:type="type"
				:placeholder="placeholder"
				:value="value"
				:name="name"
				:maxlength="maxlength"
				:data-test="name"
				@input="input"
				@blur="blur"
				@focus="focus"
			/>
			<small v-if="maxlength && hasCounter" class="help counter"
				>{{ valuelength }} / {{ maxlength }}</small
			>
		</div>
		<p v-if="showError" class="help is-danger" :data-test="`error-${name}`">
			{{ error }}
		</p>
		<slot />
	</div>
</template>

<script>
import fieldMixin from "@lab/utils/fieldMixin";
export default {
	mixins: [fieldMixin],
	props: {
		placeholder: {
			type: String,
			default: () => null
		},
		type: {
			type: String,
			default: "text"
		},
		label: {
			type: String,
			default: () => null
		},
		hasAddons: {
			type: Boolean,
			default: () => false
		},
		fieldSize: {
			type: String,
			default: () => ""
		},
		hasCounter: {
			type: Boolean,
			default: () => false
		},
		maxlength: {
			type: Number,
			default: () => null
		},
		whitelist: {
			type: Boolean,
			default: () => false
		}
	},
	computed: {
		valuelength() {
			return this.value ? this.value.length : 0;
		}
	}
};
</script>

<style lang="scss"></style>
